import { MIN_PASS_LENGTH } from '@/constants/const'

export function notEmptyRule(t) {
  console.log('notEmptyRule ', t)
  return [v => !!v || t('validation.required')]
}

export function nameRules(t) {
  return [v => (v?.length <= 10) || t('validation.nameTooLong')]
}

export function emailRules(t) {
  return [
    v => /.+@.+\..+/.test(v) || t('validation.email')
  ]
}

export function phoneRules(t) {
  return [
    v => !!v || t('validation.phoneRequired'),
    v => (v && v.replace(/\D/g, '').length >= 10) || t('validation.phoneInvalid')
  ]
}

export function pwdRules(t) {
  return [
    v => !!v || t('validation.passwordRequired'),
    v => (v && v.length) >= MIN_PASS_LENGTH || t('validation.minCharacters', { count: MIN_PASS_LENGTH })
  ]
}

export function urlRules(t) {
  return [
    v => (/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\\/\w .-]*)*\/?$/.test(v) || !v?.length) || t('validation.urlInvalid')
  ]
}

export function stateRules(t) {
  return [v => /(US|us)/.test(v) || t('validation.usOnly')]
}

export function agreeRules(t) {
  return [
    v => !!v || t('validation.mustAgree')
  ]
}

export function loginEmailRules() {
  return []
}

export function loginPwdRules() {
  return []
}

export function regEmailRules() {
  return []
}

export function regPwdRules() {
  return []
}

export function regCfmPwdRules() {
  return []
}

export function regAgreeRules() {
  return []
}

export function confirmFormPwdRules() {
  return []
}

export function confirmFormCfmPwdRules() {
  return []
}






